import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Skeleton,
} from '@mui/material';
import { useGetCompetitionsQuery } from 'src/api/competitions/getCompetitions';
import { CompetitionType } from 'src/types/domain.types';

interface CompetitionFormControlProps {
  value: number;
  onChange: (event: any) => void;
}

export const CompetitionFormControl = ({
  value,
  onChange,
}: CompetitionFormControlProps) => {
  const { data: competitionsOptions = [], isLoading } =
    useGetCompetitionsQuery();

  if (isLoading) return <Skeleton variant='rounded' width='100%' height={50} />;

  return (
    <FormControl fullWidth>
      <InputLabel id='competition'>Competition</InputLabel>
      <Select
        id='competition_id'
        label='Competition'
        labelId='competition'
        value={value}
        onChange={onChange}
      >
        {competitionsOptions.map((competition: CompetitionType) => (
          <MenuItem
            key={competition.competition_id}
            value={competition.competition_id}
          >
            {competition.name_en}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
